import { useActionFeedbackContext } from '@/contexts/ActionFeedbackContext';
import { extractErrorMessage } from '@/lib/feedback';

export function useActionFeedback() {
  const { notify } = useActionFeedbackContext();

  return {
    success: (title: string, description?: string) => {
      notify({ title, description, type: 'success', addToActivity: true });
    },
    info: (title: string, description?: string) => {
      notify({ title, description, type: 'info', addToActivity: true });
    },
    error: (title: string, error: unknown) => {
      notify({
        title,
        description: extractErrorMessage(error),
        type: 'error',
        addToActivity: true,
      });
    },
  };
}
